import { render, staticRenderFns } from "./eyeDiseasePage.vue?vue&type=template&id=39f279b3&scoped=true&"
import script from "./eyeDiseasePage.vue?vue&type=script&lang=js&"
export * from "./eyeDiseasePage.vue?vue&type=script&lang=js&"
import style0 from "./eyeDiseasePage.vue?vue&type=style&index=0&id=39f279b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f279b3",
  null
  
)

export default component.exports